import React from 'react'
import { TextField } from '@fs/zion-ui'
import { MenuFilter } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'

export default function FilterInput({ filterValue, onFilterChange, textFieldProps = {} }) {
  const [t] = useTranslation()

  const handleChange = (e) => {
    onFilterChange(e.target.value)
  }

  return (
    <TextField
      Icon={MenuFilter}
      placeholder={t('select-person.filter-placeholder', 'Filter by name')}
      label={t('select-person.filter-label', 'Filter by name')}
      value={filterValue}
      onChange={handleChange}
      data-testid="filter-by-name-input"
      {...textFieldProps}
    />
  )
}
